
const NOT_EXTENDED = 'Not Extended'
const NOT_ACCEPTABLE = 'Not Acceptable'
const PRECONDITION_FAILED = 'Precondition Failed'

export const CaptureErrorEnum = {
    "-1": {
        descriptioError: 'Biometrics device performed an internal error.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-2": {
        descriptioError: 'Communication protocole error',
        resultOperation: PRECONDITION_FAILED,
    },
    "-3": {
        descriptioError: 'Can not connect biometrics device',
        resultOperation: PRECONDITION_FAILED,
    },
    "-4": {
        descriptioError: 'Error while closing communication port.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-7": {
        descriptioError: 'Not enough memory for the creation of a database in the MSO.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-19": {
        descriptioError: 'Capture time exceeded',
        resultOperation: PRECONDITION_FAILED,
    },
    "-26": {
        descriptioError: 'Command has been aborted',
        resultOperation: PRECONDITION_FAILED,
    },
    "-34": {
        descriptioError: 'Serial COM has not been opened.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-48": {
        descriptioError: 'The Morpho MorphoSmart Service Provider Usb Server is stopped or not installed.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-57": {
        descriptioError: 'The device is locked.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-58": {
        descriptioError: 'The device is not locked.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-120": {
        descriptioError: 'The MSO Device is broken. Host should try to reboot device.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-46": {
        descriptioError: 'False Finger Detected.',
        resultOperation: 'conflict',
    },
    "-75": {
        descriptioError: 'The finger is invalid.',
        resultOperation: 'conflict',
    },
    "-5": {
        descriptioError: 'Invalid parameter.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-10": {
        descriptioError: 'The database is full.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-11": {
        descriptioError: 'The databases is empty',
        resultOperation: PRECONDITION_FAILED,
    },
    "-12": {
        descriptioError: 'User has already been enrolled.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-13": {
        descriptioError: 'The specified base does not exist.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-14": {
        descriptioError: 'The specified base already exist.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-17": {
        descriptioError: 'The template is not valid.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-18": {
        descriptioError: 'Command not yet implemented in this release.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-21": {
        descriptioError: 'Field does not exist.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-22": {
        descriptioError: 'Class has been corrupted.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-27": {
        descriptioError: 'Invalid PK format.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-29": {
        descriptioError: 'The number of the additional field is more than 128.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-31": {
        descriptioError: 'The user data are not valid.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-32": {
        descriptioError: 'Additional field name length is more than MORPHO_FIELD_NAME_LEN.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-35": {
        descriptioError: 'This element is already present in the list.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-38": {
        descriptioError: 'The Compression is not valid.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-39": {
        descriptioError: 'Security error.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-40": {
        descriptioError: 'The MSO has not the certificate necessary to verify the signature.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-41": {
        descriptioError: 'The class has been destroyed.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-43": {
        descriptioError: 'The certificate is not valid.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-49": {
        descriptioError: 'No parameter has been initialized.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-62": {
        descriptioError: 'Security level mismatch: attempt to match fingerprint template in high security level (MorphoSmartTM FINGER VP only).',
        resultOperation: PRECONDITION_FAILED,
    },
    "-64": {
        descriptioError: 'A required license is missing.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-65": {
        descriptioError: 'The MorphoSmartTM FINGER VP was unsuccessful in making a multimodal template compatible with advanced security levels.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-69": {
        descriptioError: 'A required key is missing.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-71": {
        descriptioError: 'The MorphoSmartTM FINGER VP was unsuccessful in making a multimodal template compatible with advanced security levels.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-76": {
        descriptioError: 'User area data is not empty.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-126": {
        descriptioError: 'FFD Module Not Present.',
        resultOperation: PRECONDITION_FAILED,
    },
    "-20": {
        descriptioError: 'No templates have been registered (using C_MORPHO_TemplateList::PutTemplate).',
        resultOperation: 'conflict',
    },
    "-47": {
        descriptioError: 'The finger can be too moist or the scanner is wet.',
        resultOperation: 'conflict',
    },
    "-63": {
        descriptioError: 'Misplaced or withdrawn finger has been detected during acquisition (MorphoSmartTM FINGER VP only).',
        resultOperation: 'conflict',
    },
    "-66": {
        descriptioError: 'The MorphoSmartTM was unsuccessful in capturing the fingerprint with a quality greater than or equal to the specified threshold.',
        resultOperation: 'conflict',
    },
    "-68": {
        descriptioError: 'Misplaced finger has been detected by FFD during acquisition (MorphoSmartTM MSO 3x1 FFD only)',
        resultOperation: 'conflict',
    },
    "-73": {
        descriptioError: 'The finger moved during acquisition or removed earlier.',
        resultOperation: 'conflict',
    },
    "-74": {
        descriptioError: 'The finger can be too shiny or too much external light.',
        resultOperation: 'conflict',
    },
    "-78": {
        descriptioError: 'Capture has failed.',
        resultOperation: 'conflict',
    },
    "-9": {
        descriptioError: 'Failure',
        resultOperation: NOT_ACCEPTABLE,
    },
    "6": {
        descriptioError: 'Bad fingerprint quality',
        resultOperation: NOT_ACCEPTABLE,
    },
    "34": {
        descriptioError: 'False Finger (or dead finger) suspected',
        resultOperation: NOT_ACCEPTABLE,
    },
    "35": {
        descriptioError: 'Unable to capture the fingerprint because the sensor',
        resultOperation: NOT_ACCEPTABLE,
    },
    "105": {
        descriptioError: 'Finger image is too small',
        resultOperation: NOT_ACCEPTABLE,
    },
    "184": {
        descriptioError: 'Cryptographic key not found',
        resultOperation: NOT_ACCEPTABLE,
    },
    "201": {
        descriptioError: 'Stop',
        resultOperation: NOT_ACCEPTABLE,
    },
    "202": {
        descriptioError: 'Fingerprint module busy',
        resultOperation: NOT_ACCEPTABLE,
    },
    "240": {
        descriptioError: 'Failed to initialize the captor',
        resultOperation: NOT_ACCEPTABLE,
    },
    "255": {
        descriptioError: 'El convenio de autenticación no existe o no está activo.',
        resultOperation: NOT_ACCEPTABLE,
    },
    "1001": {
        descriptioError: 'An unexpected error occurred during the execution of the command',
        resultOperation: NOT_EXTENDED,
    },
    "1002": {
        descriptioError: 'La oficina, no existe para el cliente.',
        resultOperation: NOT_EXTENDED,
    },
    "1003": {
        descriptioError: 'El producto, no existe para el cliente.',
        resultOperation: NOT_EXTENDED,
    },
    "1004": {
        descriptioError: 'El tipo de identidad para la máquina, no existe.',
        resultOperation: NOT_EXTENDED,
    },
    "1005": {
        descriptioError: 'La máquina, no pertenece a la oficina.',
        resultOperation: NOT_EXTENDED,
    },
    "1006": {
        descriptioError: 'La máquina, no existe para el cliente.',
        resultOperation: NOT_EXTENDED,
    },
    "1007": {
        descriptioError: 'La máquina ingresada para la consulta no existe.',
        resultOperation: NOT_EXTENDED,
    },
    "1008": {
        descriptioError: 'El cliente no existe o no está activo.',
        resultOperation: NOT_EXTENDED,
    },
    "1009": {
        descriptioError: 'El tipo de documento, no es válido para el convenio.',
        resultOperation: NOT_EXTENDED,
    },
    "1010": {
        descriptioError: 'El tipo de documento, no existe.',
        resultOperation: NOT_EXTENDED,
    },
    "1011": {
        descriptioError: 'Error al crear o actualizar la solicitud.',
        resultOperation: NOT_EXTENDED,
    },
    "1012": {
        descriptioError: 'La solicitud, está siendo o ya fue utilizada y no se puede cancelar.',
        resultOperation: NOT_EXTENDED,
    },
    "1013": {
        descriptioError: 'La solicitud, no existe para el cliente.',
        resultOperation: NOT_EXTENDED,
    },
    "1014": {
        descriptioError: 'El estado no existe.',
        resultOperation: NOT_EXTENDED,
    },
    "1015": {
        descriptioError: 'El resultado no existe.',
        resultOperation: NOT_EXTENDED,
    },
    "1016": {
        descriptioError: 'No existen procesos para la solicitud.',
        resultOperation: NOT_EXTENDED,
    }
};



// WEBPACK FOOTER //
// ./src/app/enums/capture-error-enum.ts